import { render, staticRenderFns } from "./ResumePickUpAndReturn.vue?vue&type=template&id=794b4ee7"
import script from "./ResumePickUpAndReturn.vue?vue&type=script&lang=js"
export * from "./ResumePickUpAndReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports